import { useState } from "react";
import ReactExport from "@ibrahimrahmani/react-export-excel";

import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

const GeneradorExcelExpedientes = ({
  obtenerDatos,
  tipo,
  disabled = false,
}) => {
  const [datosExcel, setDatosExcel] = useState([]);
  const [generando, setGenerando] = useState(false);

  // Cada vez que aumenta, fuerza a montar un ExcelFile nuevo.
  // Al tener hideElement, se descarga automáticamente.
  const [exportId, setExportId] = useState(0);

  const tipoSeleccionado = Number(tipo);

  const handleExportar = async () => {
    if (disabled || generando) {
      return;
    }

    try {
      setGenerando(true);

      const datos = await obtenerDatos();

      if (!Array.isArray(datos) || datos.length === 0) {
        return;
      }

      setDatosExcel(datos);

      // Fuerza un ExcelFile nuevo y por lo tanto una nueva descarga
      setExportId((prev) => prev + 1);

    } catch (error) {
      console.error("Error generando Excel:", error);
    } finally {
      setGenerando(false);
    }
  };

  const botonExcel = (
    <IconButton
      title={
        generando
          ? "Generando Excel..."
          : "Exportar a Excel"
      }
      disabled={disabled || generando}
      onClick={handleExportar}
    >
      {generando ? (
        <CircularProgress size={20} />
      ) : (
        <FileDownloadOutlinedIcon />
      )}
    </IconButton>
  );

  const generarExcel = () => {
    if (datosExcel.length === 0) {
      return null;
    }

    /*
     * TIPO 1
     * Generados por dependencia
     */
    if (tipoSeleccionado === 1) {
      return (
        <ExcelFile
          key={exportId}
          filename="listado-expedientes"
          hideElement
        >
          <ExcelSheet
            data={datosExcel}
            name="Expedientes"
          >
            <ExcelColumn
              label="NUMERO_EXPEDIENTE"
              value="expediente"
            />

            <ExcelColumn
              label="FECHA_INICIO"
              value="fechaInicio"
            />

            <ExcelColumn
              label="CODIGO_TEMA"
              value="codigo_tema"
            />

            <ExcelColumn
              label="TEMATICA"
              value="tematica"
            />

            <ExcelColumn
              label="ORF_ID_GENERADOR"
              value="orf_id_generador"
            />

            <ExcelColumn
              label="DESCRIPCION_COMPLETA"
              value="descripcion"
            />

            <ExcelColumn
              label="ASUNTO"
              value="asunto"
            />
          </ExcelSheet>
        </ExcelFile>
      );
    }

    /*
     * TIPO 2
     * Por temáticas
     */
    if (tipoSeleccionado === 2) {
      const mostrarOrganismo = datosExcel.some(
        (item) => item.organismo !== undefined
      );

      // SIN código de organismo
      if (mostrarOrganismo) {
        return (
          <ExcelFile
            key={exportId}
            filename="expedientes-por-tematica"
            hideElement
          >
            <ExcelSheet
              data={datosExcel}
              name="Resumen por temática"
            >
              <ExcelColumn
                label="Temática"
                value="tematica"
              />

              <ExcelColumn
                label="Tipo trámite"
                value="digital"
              />

              <ExcelColumn
                label="Organismo"
                value="organismo"
              />

              <ExcelColumn
                label="Cantidad"
                value="cantidad"
              />
            </ExcelSheet>
          </ExcelFile>
        );
      }

      // CON código de organismo
      return (
        <ExcelFile
          key={exportId}
          filename="expedientes-por-tematica"
          hideElement
        >
          <ExcelSheet
            data={datosExcel}
            name="Resumen por temática"
          >
            <ExcelColumn
              label="Temática"
              value="tematica"
            />

            <ExcelColumn
              label="Tipo trámite"
              value="digital"
            />

            <ExcelColumn
              label="Cantidad"
              value="cantidad"
            />
          </ExcelSheet>
        </ExcelFile>
      );
    }

    /*
     * TIPO 3
     * Se encuentra en dependencia
     */
    if (tipoSeleccionado === 3) {
      return (
        <ExcelFile
          key={exportId}
          filename="listado-expedientes"
          hideElement
        >
          <ExcelSheet
            data={datosExcel}
            name="Expedientes"
          >
            <ExcelColumn
              label="NUMERO_EXPEDIENTE"
              value="expediente"
            />

            <ExcelColumn
              label="FECHA"
              value="fecha"
            />

            <ExcelColumn
              label="CODIGO_TEMA"
              value="codigo_tema"
            />

            <ExcelColumn
              label="TEMATICA"
              value="tematica"
            />

            <ExcelColumn
              label="CODIGO_ORGANISMO"
              value="orf_id_destino"
            />

            <ExcelColumn
              label="DESCRIPCION_COMPLETA"
              value="descripcion"
            />

            <ExcelColumn
              label="ASUNTO"
              value="asunto"
            />
          </ExcelSheet>
        </ExcelFile>
      );
    }

    return null;
  };

  return (
    <>
      {botonExcel}
      {generarExcel()}
    </>
  );
};

export default GeneradorExcelExpedientes;